import {createModel} from '@rematch/core';
import {RootModel} from './index';


interface IMainState {
    selectedId: string;
    selectedRoom: string;
    bufferId: string;
    viewProfile: boolean;
}


const init: IMainState = {
    selectedId: 'metaverse',
    selectedRoom: 'metaverse',
    bufferId: '',
    viewProfile: false,
};

export const Main = createModel<RootModel>()({
    state: init,
    reducers: {
        update(state: IMainState, payload: Partial<IMainState>) {
            return {...state, ...payload};
        },
    },
    effects: () => ({}),
});
